import {NgModule} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {AmountInputComponent} from "./amount-input.component";
import {NumberInputModule} from "../../number/number-input/number-input.module";

@NgModule({
    declarations: [
        AmountInputComponent,
    ],
    exports: [
        AmountInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        NumberInputModule,
    ]
})
export class AmountInputModule {}
